import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutMultiSendRateConfirmation extends Layout {
    labelErrorCount: Label;
    labelErrors: Label;
    labelTotal: Label;
    labelTotalCount: Label;
    panelCounts: Panel;
    panelHeader: Panel;
    panelReady: Panel;
    panelTotal: Panel;
    sourceMultiSendRateCon: DataSource;
    tableMultiRateCon: Table;
}
